import { useCallback, useState } from "react";
import { Psychologist } from "../../../models/Psychologist";
import AssessmentPsychologistRepository from "../../../repositories/AssessmentPsychologist";

export const useGetAssessmentPsychologists = (assessment_id: number | string) => {
  const [data, setData] = useState<Psychologist[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [totalData, setTotalData] = useState<number>(0);

  const loadData = useCallback(async () => {
    setIsLoading(true);

    await AssessmentPsychologistRepository.findAll(assessment_id)
      .then((response) => {
        const { data: responseData, meta } = response.data;
        setData(responseData);
        setTotalData(meta.total);
      })
      .catch(() => {})
      .finally(() => {
        setIsLoading(false);
      });
  }, [assessment_id]);

  return {
    data,
    isLoading,
    loadData,
    totalData,
  };
};
